import React, {useEffect, useState} from 'react';
import API from "../../utils/API";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import InfutorDataDisplay from "./InfutorDataDisplay";
import InfutorPersonDataDisplay from "./InfutorPersonDataDisplay";

const InfutorDataLookupLead = ({lead = null, phone = null, firstName = null, lastName = null, address = null, city = null, state = null, zip = null}) => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [modalshow, setModalshow] = useState(false);

    const lookUp = () => {
        setLoading(true);
        API.post(phone ? "/admin/scrubber/infutorphonelookup" : "/admin/scrubber/infutorpersonlookup",{lead, phone, firstName, lastName, address, city, state, zip}).then((response) => {
            setLoading(false);
            setResult(response.data.data);
            setModalshow(true);
        });
    };


    return <>
        <button className="btn btn-info btn-sm" onClick={()=>lookUp()}>Infutor Verify</button>
        {result &&
            <>
                <React.Fragment>
                    <Modal
                        isOpen={modalshow}
                        toggle={() => {
                            if (modalshow) {
                                setModalshow(false);
                            }
                            setModalshow(!modalshow)
                        }}
                        size="lg"
                        style={{maxWidth: '1200px', width: '90%'}}
                        onClose={() => setModalshow(false)}
                    >
                        <ModalHeader toggle={() => {
                            if (modalshow) {
                                setModalshow(false);
                            }
                            setModalshow(!modalshow)
                        }}>
                            {phone ?
                                <>Phone Owner ID Validation</>
                                :
                                <>Name Lookup</>
                            }
                        </ModalHeader>
                        <ModalBody style={{backgroundColor:"#F7F9FC"}}>
                            {phone ?
                                <InfutorDataDisplay data={result}/>
                            :
                                <InfutorPersonDataDisplay data={result}/>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => {setModalshow(false);}}>
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                </React.Fragment>
            </>
        }
    </>
}

export default InfutorDataLookupLead;
